import {
  DeleteDashboardDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteDashboard = createMutationHook({
  name: 'deleteDashboard',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.dashboard.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { Id: string }) => ({ Id: variables.Id }),
  invalidate: (trpc) => [
    trpc.frontend.dashboard.dashboards.queryKey(),
    trpc.frontend.dashboard.dashboardById.queryKey(),
  ],
  mapResponse: (): void => undefined,
  graphqlDocument: DeleteDashboardDocument,
  graphqlVariables: (variables: { Id: string }) => ({ Id: variables.Id }),
  // Original wrapper discarded the mutation response and returned void on
  // both paths — preserve that instead of surfacing the raw document shape.
  mapGraphqlResponse: (): void => undefined,
  refetchQueries: [namedOperations.Query.getDashboards],
});
